import { IdentityPoolService } from '~src/authentication/services/IdentityPoolService';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { siteUserAddToIdentityPool } from '~src/userManagement/users/actions/SiteUserMenuActions';
import { ISiteUserInfo } from '~src/userManagement/users/models/ISiteUserInfo';

export const SiteUserAddToIdentityPoolAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserAddToIdentityPool,
  translateName: Messages.identityPools_SiteUserAction_SiteUserAddToIdentityPool,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return FeatureFlags.identityPoolsEnabled && _targetItems.length === 1 && IdentityPoolService.hasIdentityPools();
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return targetItems.length === 1;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserAddToIdentityPool(targetItems)
};
